import Vue from 'vue';
const InformeEventBus = new Vue();
export default InformeEventBus;
